<template>
  <div id="message-list">
    <van-nav-bar fixed left-arrow @click-left="back" class="tltle">
      <div slot="title">消息列表</div>
    </van-nav-bar>
    <div class="tab-btns news">
      <div v-bind:class="{cur:index === 1}" @click="tabChange(1)">全部消息</div>
      <div v-bind:class="{cur:index === 2}" @click="tabChange(2)" v-cloak>未读消息（{{notRead || 0}}）</div>
      <span></span>
    </div>
    <div class="searchScreen">
      <van-search
        v-model="searchName"
        placeholder="请输入要查询的内容"
        shape="round"
        @search="nameSearch"
        style="width:70%;"
      ></van-search>
      <div class="fr allRead" @click="readAll">全部标为已读</div>
    </div>

    <van-list
      class="news-list"
      v-model="listLoading"
      :finished="finished"
      finished-text="没有更多数据了"
      @load="getSelfMessage"
      v-show="SelfMessageList.length !== 0"
      v-bind:callback="getSelfMessage"
    >
      <van-cell
        class="news-item"
        v-for="item in SelfMessageList"
        :key="item.MessageID"
        v-bind:class="{isRead:item.Status === 1}"
      >
        <messageCard :SelfMessageList="item" :pathSource="pathSource" />
      </van-cell>
      <!-- <img slot="loadingTip" src="../../../../../image/mobileLoading.svg" style="width:20px;" /> -->
    </van-list>

    <div v-show="SelfMessageList.length === 0 " class="xy-phone-no-data">
      <img src="../../../../assets/basic/moblie-no-data.png" />
      <p>暂无消息</p>
    </div>
  </div>
</template>
<script>
import messageCard from "@/pages/common/views/message/components/messageCard.vue";
export default {
  name: "messageList",
  data() {
    return {
      page: 1,
      pageSize: 10,

      SelfMessageList: [],
      index: 1, //tab切换展示
      searchName: "", //搜索
      notRead: 0,
      status: -1,
      pathSource: "messageList",

      finished: false,
      listLoading: false
    };
  },
  components: {
    messageCard
  },
  created() {
    this.getSelfMessage(); // 获取全部消息
    this.getNotRead(); //获取未读数
  },
  methods: {
    tabChange: function(index) {
      this.searchName = "";
      if (index === 1) {
        this.index = 1;
        // 获取全部消息
        this.page = 1;
        this.SelfMessageList = [];
        this.status = -1;
        this.getSelfMessage();
      } else {
        this.index = 2;
        // 获取全部未读消息
        this.page = 1;
        this.SelfMessageList = [];
        this.status = 0;
        this.getSelfMessage();
      }
    },
    //获取未读
    async getNotRead() {
      let res = await this.xyapi.get(
        this.xyMApi + "/msg/api/Message/GetTotalNotRead",
        null
      );
      // console.log("未读", res);
      if (res && res.success) {
        this.notRead = res.data;
      }
    },
    // 获取全部消息
    async getSelfMessage() {
      var that = this;
      var params = {
        // -1全部消息，0未读消息，1已读消息
        status: this.status,
        beginDate: "",
        endDate: "",
        pageIndex: that.page,
        pageSize: that.pageSize,
        query: that.searchName
      };
      this.xy.loading();
      let res = await this.xyapi.get(
        this.xyMApi + "/msg/api/Message/GetPageSelf",
        params
      );

      this.xy.unloading();
      if (res && res.success && res.data && res.data.data) {
        if (res.data.data !== null && res.data.data.length > 0) {
          var totalPages = Math.ceil(res.data.totalRecords / that.pageSize); //总页数

          var _list = res.data.data;
          that.SelfMessageList = [...that.SelfMessageList, ..._list];

          /* 单次请求数据完毕 */
          this.listLoading = false;
          if (that.page >= totalPages) {
            /* 所有数据加载完毕 */
            that.finished = true;
            return;
          }
          that.page++;
        } else {
          that.SelfMessageList = [];
          that.finished = true;
        }
      }
    },
    //全部已读
    async readAll() {
      var _this = this;
      if (_this.notRead === 0) {
        this.xy.msgError("暂无未读消息！");
        return false;
      }
      let params = {
        status: 1
      };
      let res = await this.xyapi.post(
        this.xyMApi +
          `/msg/api/Message/SetStatusAllByUserID?status=${params.status}`
      );

      if (res && res.success) {
        this.xy.msgSuc("设置成功！");
        //刷新页面
        _this.notRead = 0;
        if (this.index === 1) {
          for (var i = 0; i < _this.SelfMessageList.length; i++) {
            _this.SelfMessageList[i].Status = 1;
          }
        } else {
          _this.SelfMessageList = []; //页面清空未读消息
        }
      }
    },
    back: function() {
      this.$router.go(-1);
    },

    searchReset: function() {
      this.page = 1;
      this.SelfMessageList = [];
      this.getSelfMessage();
    },
    //搜索内容为空时展示全部
    inputFunc: function() {
      if (this.searchName.trim() === "") {
        this.searchName = "";
        this.searchReset(this.index);
      }
    },
    //搜索
    nameSearch: function(value) {
      this.searchName = value;
      this.searchReset(this.index);
    }
  },
  watch: {
    // searchName: function () {
    // },
  }
};
</script>
<style lang="less" >
#message-list {
  padding-top: 90px;

  .van-list .van-cell {
    line-height: normal !important;
  }
  .tltle {
    background: #4196ff;
    height: 90px;
    line-height: 90px;
  }

  .tltle div {
    color: #ffffff;
  }
  .van-icon-arrow-left:before {
    color: #ffffff;
  }
  .van-icon-arrow:before {
    font-size: 22px;
  }
  .van-search {
    padding: 0px 12px;
  }
  .van-search__content {
    padding-left: 32px;
    background: #f2f2f2;
    height: 62px;
  }
  input::-webkit-input-placeholder {
    font-family: arial, sans-serif;
    color: #b2b2b2;
    font-size: 26px;
  }
  .van-icon-search:before {
    color: #b2b2b2;
  }

  .tab-btns.news {
    padding: 0 50px;
  }
  .tab-btns {
    display: flex;
    font-size: 28px;
    height: 88px;
    line-height: 88px;
    background: #fff;
    color: #acacac;
    position: relative;
    span {
      position: absolute;
      width: 2px;
      height: 44px;
      background: #e1e1e1;
      left: 50%;
      top: 22px;
    }
    div {
      flex: 1;
      text-align: center;
    }
    div.cur {
      color: #2b303b;
      font-weight: bold;
    }
  }
  .searchScreen {
    background: #fff;
    padding: 0 19px 13px 19px;
    border-bottom: 1px solid #f5f5f5;
    display: flex;
    justify-content: space-between;
    .allRead {
      height: 62px;
      width: 200px;
      line-height: 62px;
      background: #4a98fd;
      color: #fff;
      padding: 0 15px;
      border-radius: 31px;
      text-align: center;
      font-size: 24px;
    }
  }

  // 没有数据
  .xy-phone-no-data {
    width: 100%;
    height: 50%;
    overflow: hidden;
    margin: 40% auto 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    text-align: center;
  }

  .xy-phone-no-data p {
    font-size: 16px;
    text-align: center;
  }
}
</style>
